
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parking-search",
      function () {
        return require("private-next-pages/parking-search/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/parking-search"])
      });
    }
  